/* @flow */
import { I18n } from 'react-redux-i18n'

import {
  INIT_AUTH,
  SHOW_LOGIN,
  HIDE_LOGIN,
  SHOW360,
  HIDE360,
  GET_HOME_RESOURCES,
  GET_RESOURCES,
  LOGIN,
  LOGOUT,
  REGISTER,
  TO_REGISTER,
  SEARCH,
  UPDATE_ACCOUNT,
  SHOW_ALERT,
  HIDE_ALERT,
  CHANGE_CURRENCY,
  FORGOT_PASSWORD,
  SHOW_LOADING,
  HIDE_LOADING,
  SHOW_MESSAGE_MODAL,
  HIDE_MESSAGE_MODAL,
  SEND_MESSAGE,
  GET_MESSAGES,
  divingExps,
  UPDATE_LOCAL_ANNOUNCEMENTS,
  GET_CATEGORIES,
  UPDATE_CATEGORIES_STATE,
} from '../configs/constants'

export function showLoading() {
  return { type: SHOW_LOADING }
}

export function hideLoading() {
  return { type: HIDE_LOADING }
}

export function initAuth() {
  return { type: INIT_AUTH }
}

export function showLogin() {
  return { type: SHOW_LOGIN }
}
export function hideLogin() {
  return { type: HIDE_LOGIN }
}
export function login(params) {
  return { type: LOGIN, params }
}
export function toRegister() {
  return { type: TO_REGISTER, registerInfo: {} }
}
export function register(params) {
  return { type: REGISTER, params }
}
export function logout() {
  return { type: LOGOUT }
}
export function updateAccount({
  uid,
  idType,
  id,
  firstName,
  lastName,
  displayName,
  gender,
  birthday,
  phoneNumber,
  email,
  divingLicense,
  divingExperience
}) {
  return { type: UPDATE_ACCOUNT,
    profile: {
      uid,
      idType: idType || { label: I18n.t('id'), value: 'id' },
      id: id || '',
      firstName: firstName || '',
      lastName: lastName || '',
      displayName: displayName || '',
      gender: gender || '',
      birthday: birthday || null,
      phoneNumber: phoneNumber || '',
      email: email || '',
      divingLicense: !!divingLicense,
      divingExperience: divingExperience || divingExps[0].value,
    }
  }
}

export function show360(item) {
  return { type: SHOW360, payload: item }
}
export function hide360() {
  return { type: HIDE360 }
}

export function showAlert(message, title, type, useConfirmBtn, onConfirm, onClose) {
  return { type: SHOW_ALERT, payload: {
    isShown: true,
    message,
    title,
    type,
    useConfirmBtn,
    onConfirm,
    onClose,
  } }
}

export function hideAlert() {
  return { type: HIDE_ALERT, payload: { isShown: false } }
}

export function getHomeResources() {
  return { type: GET_HOME_RESOURCES }
}

export function getResources() {
  return { type: GET_RESOURCES }
}

export function getCategories() {
  return { type: GET_CATEGORIES }
}

export function updateCategoriesState(categories) {
  return {
    type: UPDATE_CATEGORIES_STATE,
    categories
  }
}

export function updateLocalAnnouncements(announcements) {
  return {
    type: UPDATE_LOCAL_ANNOUNCEMENTS,
    announcements
  }
}

export function search(keyword, startDate, endDate, experience) {
  return { type: SEARCH, payload: { keyword, startDate, endDate, experience } }
}

export function changeCurrency(currency) {
  return { type: CHANGE_CURRENCY, payload: currency }
}

export function forgotPassword(email) {
  return { type: FORGOT_PASSWORD, email }
}

export function getMessages(displayName, email) {
  return { type: GET_MESSAGES, payload: { displayName, email } }
}

export function showMessageModal(params) {
  return { type: SHOW_MESSAGE_MODAL, payload: params }
}

export function hideMessageModal() {
  return { type: HIDE_MESSAGE_MODAL }
}

export function sendMessage(messageInfo) {
  return { type: SEND_MESSAGE, payload: messageInfo }
}


// WEBPACK FOOTER //
// ./src/actions/global.js